var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.68 14.1504H5.30222C2.936 14.1504 1 16.123 1 18.5339V20.7256",
    stroke: "#92C99A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.60447 9.76697C11.9805 9.76697 13.9067 7.80441 13.9067 5.38348C13.9067 2.96255 11.9805 1 9.60447 1C7.22842 1 5.30225 2.96255 5.30225 5.38348C5.30225 7.80441 7.22842 9.76697 9.60447 9.76697Z",
    stroke: "#92C99A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0001 15.9341C23.0001 20.8157 16.8401 24.9999 16.8401 24.9999C16.8401 24.9999 10.6801 20.8157 10.6801 15.9341C10.6801 12.4472 13.4178 9.65771 16.8401 9.65771C20.2623 9.65771 23.0001 12.5169 23.0001 15.9341Z",
    stroke: "#92C99A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8401 18.026C17.9741 18.026 18.8934 17.0894 18.8934 15.9339C18.8934 14.7785 17.9741 13.8418 16.8401 13.8418C15.7061 13.8418 14.7867 14.7785 14.7867 15.9339C14.7867 17.0894 15.7061 18.026 16.8401 18.026Z",
    stroke: "#92C99A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitsActive);
export default __webpack_public_path__ + "static/media/visits-active.a074ac5a3a8e70a9aa1396687cca972b.svg";
export { ForwardRef as ReactComponent };